import { getAuth } from 'quartz-auth/app/service';
export const getIsAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};

/* Synchronously reads the authed user's email from quartz-auth.
 * Returns true for @hubspot.com users. In-app equivalent of the public
 * app's getIsHubSpotterSync (which reads the COOKIE_ECHO_USER early request). */
export const getIsHubSpotter = () => {
  var _getAuth;
  const email = (_getAuth = getAuth()) === null || _getAuth === void 0 || (_getAuth = _getAuth.user) === null || _getAuth === void 0 ? void 0 : _getAuth.email;
  return typeof email === 'string' && email.endsWith('@hubspot.com');
};